module.exports = __webpack_public_path__ + "img/jzy_pic_service.35f033fe.png";